if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.innerForm = this.querySelector('.product-form--inner');
        this.isFixed = false;
        this.observeScroll();
      }

      observeScroll() {
        if (!this.innerForm) return;

        const observer = new IntersectionObserver((entries) => {
          // Check if window width is less than 768px before applying animation
          if (window.innerWidth < 768) {
            entries.forEach((entry) => {
              if (!entry.isIntersecting && !this.isFixed) {
                this.innerForm.classList.add('transitioning');
                this.innerForm.style.transition = 'transform 0.3s ease-in-out';
                this.innerForm.style.transform = 'translateY(100%)';
                setTimeout(() => {
                  this.innerForm.classList.add('fixed-bottom');
                  this.innerForm.style.transform = 'translateY(0)';
                  this.isFixed = true;
                }, 300);

              } else if (entry.isIntersecting && this.isFixed) {
                this.innerForm.style.transition = 'transform 0.3s ease-in-out';
                this.innerForm.style.transform = 'translateY(100%)';
                setTimeout(() => {
                  this.innerForm.style.transition = '';
                  this.innerForm.style.transform = '';
                  this.innerForm.classList.remove('fixed-bottom');
                  this.isFixed = false;
                }, 100);
              }
            });
          }
        }, { threshold: 0.1 });

        observer.observe(this);
      }

      addToCart(config, formData) {

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                });
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner').classList.add('hidden');
            });
      }


        onSubmitHandler(evt) {
            evt.preventDefault();
            if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

            this.handleErrorMessage();

            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.classList.add('loading');
            this.querySelector('.loading__spinner').classList.remove('hidden');

            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];

            const formData = new FormData(this.form);

            const discountDataInputEarly = this.form.querySelector('[name="discount_data"]');
            const productInfo = this.closest('product-info');
            const shouldStripKachingBundles =
              !productInfo || productInfo.dataset.hideKachingBundles !== 'false';
            if (shouldStripKachingBundles && discountDataInputEarly && discountDataInputEarly.value) {
              ['properties[__kaching_bundles]', 'properties[__kaching_session_id]'].forEach((key) => {
                formData.delete(key);
              });
            }

            if (this.cart) {
                formData.append(
                    'sections',
                    this.cart.getSectionsToRender().map((section) => section.id)
                );
                formData.append('sections_url', window.location.pathname);
                this.cart.setActiveElement(document.activeElement);
            }

            let qtyContainer = document.querySelector(`[name="bundles"]:checked`);
            let quantityValue = formData.get('quantity') || 1;
            if (qtyContainer) {
                formData.delete('quantity');
                formData.append('quantity', qtyContainer.value * quantityValue);
            }

            let sellingPlanInput = this.form.querySelector('input[name="selling_plan"]');
        // &&
        //     document.querySelector('.variant-selector input:checked') &&
        //     document.querySelector('.variant-selector input:checked').value.indexOf(' x ') !== -1
            if (
                sellingPlanInput
            ) {
                formData.delete('selling_plan');
                formData.append('selling_plan', sellingPlanInput.value);

                // formData.delete('quantity');
                // formData.append('quantity', 1);
            } else {
                formData.delete('selling_plan');
            }


            config.body = formData;

            const discountDataInput = discountDataInputEarly;
            const giftIdsInput = this.form.querySelector('[name="gift_ids"]');
            const giftIdStrings = giftIdsInput?.value
              ? giftIdsInput.value.split(',').map(s => s.trim()).filter(Boolean)
              : [];

            if (giftIdStrings.length > 1) {
              this.showGiftSelectionModal(giftIdStrings.map(Number), formData, config);
              return;
            }

            this.addToCart(config, formData);

            if (giftIdStrings.length === 1) {
              const giftFormData = new FormData();
              giftFormData.append('id', giftIdStrings[0]);
              giftFormData.append('quantity', 1);
              const giftConfig = fetchConfig('javascript');
              giftConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
              delete giftConfig.headers['Content-Type'];
              giftConfig.body = giftFormData;
              fetch(`${routes.cart_add_url}`, giftConfig);
            }
        }

        showGiftSelectionModal(giftIds, formData, config) {
          const lookupEl = document.getElementById('gift-variant-lookup');
          const lookupArr = lookupEl ? JSON.parse(lookupEl.textContent) : [];
          const lookup = {};
          for (const v of lookupArr) lookup[v.id] = v;

          const buildInner = (id, idx, info) => {
            const base = info && (info.product_title || info.title)
              ? ((info.product_title || '') + (info.title && info.title !== 'Default Title' ? ' – ' + info.title : '')).trim()
              : 'Dovana ' + (idx + 1);
            const img = info && info.image
              ? '<img src="' + info.image + '" alt="" class="gift-selection-modal__img">'
              : '';
            return img + '<span>' + base + '</span>';
          };

          const renderOptions = () => giftIds.map((id, idx) => {
            const info = lookup[id];
            const disabled = (info && info.available === false) ? ' disabled' : '';
            const cls = (info && info.available === false) ? ' gift-selection-modal__option--unavailable' : '';
            return '<button class="gift-selection-modal__option' + cls + '" data-variant-id="' + id + '"' + disabled + '>'
              + buildInner(id, idx, info) + '</button>';
          }).join('');

          const modal = document.createElement('div');
          modal.id = 'gift-selection-modal';
          modal.className = 'gift-selection-modal';
          modal.innerHTML =
            '<div class="gift-selection-modal__overlay"></div>' +
            '<div class="gift-selection-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="gift-modal-title">' +
              '<button class="gift-selection-modal__close" aria-label="Uždaryti">&times;</button>' +
              '<h2 class="gift-selection-modal__title" id="gift-modal-title">Pasirinkite dovaną</h2>' +
              '<div class="gift-selection-modal__options">' + renderOptions() + '</div>' +
            '</div>';

          document.body.appendChild(modal);
          requestAnimationFrame(() => modal.classList.add('gift-selection-modal--open'));

          const resetButton = () => {
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          };

          const close = (cancelled) => {
            modal.classList.remove('gift-selection-modal--open');
            modal.addEventListener('transitionend', () => modal.remove(), { once: true });
            if (cancelled) resetButton();
          };

          const attachHandlers = () => {
            modal.querySelectorAll('.gift-selection-modal__option:not([disabled])').forEach(btn => {
              btn.addEventListener('click', () => {
                const selectedGiftId = Number(btn.dataset.variantId);
                close(false);
                const parentId = Number(formData.get('id'));
                this.addToCart(config, formData);
                fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    items: [{ id: selectedGiftId, quantity: 1, properties: { _gift_parent: parentId } }]
                  })
                });
              });
            });
          };

          modal.querySelector('.gift-selection-modal__overlay').addEventListener('click', () => close(true));
          modal.querySelector('.gift-selection-modal__close').addEventListener('click', () => close(true));
          attachHandlers();

          // Enrich unknown variants via Storefront API if token is available
          const unknownIds = giftIds.filter(id => {
            const info = lookup[id];
            return !info || (!info.product_title && !info.title);
          });
          const token = window.shopifyStorefrontToken;
          if (unknownIds.length && token) {
            const gids = unknownIds.map(id => 'gid://shopify/ProductVariant/' + id);
            fetch(window.shopUrl + '/api/2026-04/graphql.json', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': token,
              },
              body: JSON.stringify({
                query: 'query($ids:[ID!]!){nodes(ids:$ids){...on ProductVariant{id title availableForSale image{url}product{title}}}}',
                variables: { ids: gids },
              }),
            })
              .then(r => r.json())
              .then(json => {
                if (!json.data || !json.data.nodes || !modal.isConnected) return;
                json.data.nodes.forEach(node => {
                  if (!node) return;
                  const numericId = Number(node.id.split('/').pop());
                  const idx = giftIds.indexOf(numericId);
                  lookup[numericId] = {
                    id: numericId,
                    title: node.title,
                    product_title: node.product ? node.product.title : null,
                    available: node.availableForSale,
                    image: node.image ? node.image.url : null,
                  };
                  const btn = modal.querySelector('.gift-selection-modal__option[data-variant-id="' + numericId + '"]');
                  if (!btn) return;
                  btn.innerHTML = buildInner(numericId, idx, lookup[numericId]);
                  if (!node.availableForSale) {
                    btn.setAttribute('disabled', '');
                    btn.classList.add('gift-selection-modal__option--unavailable');
                  }
                });
                // Re-attach handlers after DOM update
                modal.querySelectorAll('.gift-selection-modal__option').forEach(b => {
                  const clone = b.cloneNode(true);
                  b.parentNode.replaceChild(clone, b);
                });
                attachHandlers();
              })
              .catch(() => {});
          }
        }


        handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}